<template>
    <p class="page-text--sm grey-9--text line-height-15">
        <span v-if="application.isOpenHiring"> 상시채용 {{ application?.closesOnHiring ? "(채용시 마감)" : "" }} </span>
        <span v-else> {{ startsAt }} ~ {{ endsAt }} {{ daysLeft }} {{ application?.closesOnHiring ? "(채용시 마감)" : "" }} </span>
    </p>
</template>

<script>
import dayjs from "dayjs";
import { initRecruitmentField__application } from "@/assets/variables";

const days = ["일", "월", "화", "수", "목", "금", "토"];

export default {
    props: {
        application: { type: Object, default: initRecruitmentField__application },
    },
    computed: {
        startsAt() {
            let { startsAt } = this.application || {};
            return startsAt ? `${dayjs(startsAt).format("YYYY.MM.DD")}(${days[dayjs(startsAt).day()]})` : null;
        },
        endsAt() {
            let { endsAt } = this.application || {};
            return endsAt ? `${dayjs(endsAt).format("YYYY.MM.DD")}(${days[dayjs(endsAt).day()]})` : null;
        },
        daysLeft() {
            let { daysLeft } = this.application || {};

            if (daysLeft < 0) return `D${daysLeft}`;
            if (daysLeft == 0) return "D-Day";
            if (daysLeft > 0) return "마감";

            return "상시모집";
        },
    },
};
</script>

<style>
</style>